<template>
  <el-header class="header">
    <div class="logo">
      <img :src="$store.getters.logo || defaultLogo" alt="大营家logo" />
    </div>

    <div class="headtop">
      <div class="txt">
        <el-icon size="20"><WarningFilled /></el-icon>
        为了便于您的阅读，建议使用浏览器：360极速模式、Microsoft Edge、Google 10. Firefox
        3.2以上版本访问系统。如果您的屏幕分辨率较小，请使用快捷键Ctrl+/-进行屏幕缩放。
      </div>
      <div class="system">
        <router-link to="" class="link" alt="profile"
          ><el-icon><UserFilled /></el-icon
        ></router-link>
        <div @click="logout" class="link" alt="logout">
          <el-icon><SwitchButton /></el-icon>
        </div>
      </div>
    </div>
  </el-header>
</template>

<script>

export default {
  data() {
    return {
      defaultLogo: require("@/assets/images/logo.png")
    };
    
  },
  methods: {
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  }
};
</script>

<style lang="less" scoped>

.el-header {
  padding: 0;
}
.header {
  position: fixed;
  top: 0;
  background-color: @headtop_color;
  display: flex;
  height: @headtopHeight;
  width: 100%;
  z-index: @headZindex;
  .logo {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: @leftWidth;
    text-align: center;
    border-right: 1px solid rgba(255, 255, 255, 0.05);
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .headtop {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    box-sizing: border-box;
    flex-grow: 1;
    .txt {
      color: #fff;
      font-size: 14px;
      .el-icon {
        color: @color_warning;
      }
    }
  }
  .system {
    flex-shrink: 0;
    .link {
      display: inline-block;
      margin-left: 5px;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      background-color: var(--head-icon);
      text-align: center;
      line-height: 34px;
      color: #fff;
      cursor: pointer;
      &:hover {
        background-color: @color_warning;
      }
      > * {
        opacity: 1;
      }
    }
  }
  .el-icon {
    vertical-align: middle;
  }
}
</style>
